/**
 * Ordered by variant ID (and matches the server's definitions and ordering).
 */
export const ALL_POKER_VARIANTS = ['holdEm', 'omaha', 'crazyPineapple'];
export const ALL_POKER_VARIANT_PROPERTIES = {
    holdEm: {
        name: "Texas Hold 'Em",
        shortName: "Hold 'Em",
        variantId: 0,
        getNumHoleCards: () => 2,
        allowsReveal: true,
        gameGuidePageType: 'texas',
        availableLimitTypes: ['no-limit', 'dual-limit']
    },
    omaha: {
        name: 'Omaha',
        shortName: 'Omaha',
        variantId: 1,
        getNumHoleCards: () => 4,
        allowsReveal: true,
        gameGuidePageType: 'omaha',
        availableLimitTypes: ['pot-limit']
    },
    crazyPineapple: {
        name: 'Crazy Pineapple',
        shortName: 'Crazy Pineapple', // TODO: Make shorter?
        variantId: 2,
        getNumHoleCards: (isAfterDiscardPhase) => (isAfterDiscardPhase ? 2 : 3),
        discardAfterBetRound: 2,
        allowsReveal: false,
        gameGuidePageType: 'crazy-pineapple',
        availableLimitTypes: ['no-limit', 'dual-limit']
    }
};
export function pokerVariantIndexParser(str) {
    return ALL_POKER_VARIANTS[Number(str)];
}
export function lobbyPokerVariantIndexParser(str) {
    const variantId = Number(str);
    if (variantId === ALL_POKER_VARIANTS.length) {
        // in the lobby context, a variant ID after the last "real" variant ID indicates this is a mixed game room:
        return 'mixed';
    }
    return ALL_POKER_VARIANTS[variantId];
}
